import _ from 'lodash';
import { MetadataContent } from '@jutro/legacy/uiconfig';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import PropTypes from 'prop-types';
import metadata from './HOPolicySummaryAdditionalDetailsComponent.metadata.json5';
import './HOPolicySummaryAdditionalDetailsComponent.messages';

import React from 'react';

function HOPolicySummaryAdditionalDetailsComponent(props) {
    const {
        model: policyDetails,
        isPolicyChange
    } = props;

    const isAMP = appConfig.portalCode === 'AMP';
    const additionalInterests = _.get(policyDetails, 'additionalInterests.value', []);

    const getFormattedAddress = (address) => (address ? `${address.city}, ${address.state}, ${address.postalCode}` : '');

    const showInsuredResidence = () => {
        return !isAMP || isPolicyChange;
    };

    const generateOverrides = () => {
        const overrides = additionalInterests.map((interest, index) => {
            return {
                [`additionalInterestType${index}`]: {
                    content: interest?.type
                },
                [`additionalInterestName${index}`]: {
                    content: interest?.displayFullName_Ext ? _.toUpper(interest?.displayFullName_Ext) : _.toUpper(interest?.name)
                },
                [`additionalInterestAddressLine1${index}`]: {
                    visible: !!interest?.address?.addressLine1,
                    content: interest?.address?.addressLine1
                },
                [`additionalInterestAddressLine2${index}`]: {
                    visible: !!interest?.address?.addressLine2,
                    content: interest?.address?.addressLine2
                },
                [`additionalInterestAddressLine3${index}`]: {
                    visible: !!interest?.address?.addressLine3,
                    content: interest?.address?.addressLine3
                },
                [`additionalInterestAddressCityStatePostalCode${index}`]: {
                    content: getFormattedAddress(interest?.address)
                },
                [`additionalInterestLoanNumber${index}`]: {
                    visible: !!interest?.loanNumber,
                    content: `Loan #: ${interest.loanNumber}`
                },
            };
        });
        return Object.assign({}, ...overrides);
    };

    const overrides = {
        insuredResidenceContainer: {
            visible: showInsuredResidence()
        },
        addressLine1: {
            content: _.get(policyDetails, 'policyAddress.addressLine1.value')
        },
        addressLine2: {
            content: _.get(policyDetails, 'policyAddress.addressLine2.value')
        },
        addressLine3: {
            content: _.get(policyDetails, 'policyAddress.addressLine3.value')
        },
        addressCityStatePostalCode: {
            content: getFormattedAddress(_.get(policyDetails, 'policyAddress.value'))
        },
        additionalInterestsIterable: {
            data: additionalInterests
        },
        ...generateOverrides()
    };
    return <MetadataContent uiProps={metadata.componentContent} overrideProps={overrides} />;
}

HOPolicySummaryAdditionalDetailsComponent.propTypes = {
    model: PropTypes.shape({}).isRequired,
    isPolicyChange: PropTypes.bool
};

HOPolicySummaryAdditionalDetailsComponent.defaultProps = {
    isPolicyChange: false
};

export default HOPolicySummaryAdditionalDetailsComponent;
